// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3fIvs","location":"Header_location__37PZ2"};